import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-radio-chip',
  styles: `
    .custom-radio-group {
      display: flex;
      gap: var(--mar-spacing-default-lg);
      padding-bottom: 24px;
    }

    .custom-radio {
      display: flex;
      padding: var(--mar-spacing-default-sm);
      justify-content: center;
      align-items: center;
      gap: var(--mar-spacing-default-xs);
      flex: 1 0 0;

      border-radius: var(--mar-border-radius-circular);
      background: var(--mar-foreground-tertiary-default, #F0F6FE);


      cursor: pointer;
      transition: background-color 0.2s ease;

      input[type="radio"] {
        display: none;
      }

      .label {
        color: var(--mar-foreground-primary-default);
        font-family: var(--mar-open-sans, "Open Sans"), sans-serif;
        font-size: var(--mar-font-size-14px, 14px);
        font-style: normal;
        font-weight: var(--mar-font-weight-700, 700);
        line-height: var(--mar-line-height-20px, 20px); /* 142.857% */
        letter-spacing: var(--mar-letter-spacing-0, 0px);
      }

      &:hover {
        @media (min-width: 600px) {
          background-color: var(--mar-foreground-secondary-hover);
          border: var(--mar-border-width-thin, 1px) solid var(--mar-border-secondary-hover, #CFCFCF);
        }
      }

      &.selected {
        background-color: var(--mar-foreground-tertiary-active);
      }
    }
  `,
  template: `
    @if (props.label) {
      <label>{{ props.label }}</label>
    }
    <div class="custom-radio-group">
      @for (option of optionsList; track $index) {
        <label
          class="custom-radio"
          [class.selected]="formControl.value === option.value"
          >
          <input
            (click)="emitChange()"
            type="radio"
            [value]="option.value"
            [formControl]="formControl"
            />
          <span class="label">{{ option.label }}</span>
        </label>
      }
    </div>
    `,
  standalone: false
})
export class FormlyFieldRadioChipComponent extends FieldType<FieldTypeConfig> {
  get optionsList() {
    return this.props.options as { label: string, value: string }[];
  }

  emitChange() {
    this.props.onInteraction?.();
  }
}
